import * as Sentry from '@sentry/browser';

export function setupSentry(Vue) {
  // Only enable Sentry in production, as it swallows VueJS errors
  // and generally gets in the way of debugging
  if (process.env.NODE_ENV !== 'production') {
    return;
  }

  Sentry.init({
    dsn: 'https://f209e81148d448ac89b20a7b60cbe01e@sentry.io/1341880',
    integrations: [new Sentry.Integrations.Vue({ Vue })],
    environment: process.env.NODE_ENV,
  });
}

